module.exports = __webpack_public_path__ + "static/media/getviralLogo.bf167a09.png";